import { Component, OnInit, Inject, Renderer2, HostListener, ViewChild } from '@angular/core';
import { DOCUMENT,DatePipe} from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { AccountService } from 'src/app/shared/account.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Router } from '@angular/router';
import { Client , Message ,Stomp} from '@stomp/stompjs';
import { timeStamp } from 'console';
import { environment } from 'src/environments/environment';
import companies from '../../../assets/companies.json';
import { OrderService } from '../../../app/modules/user/dropshipping/order/service/order.service';
import { LeadsService } from '../../../app/core/api/leads.service';
import { searchFilter } from '../../../app/shared/models/search-filter';
import { ProductService } from '../../core/api/product.service';
import { Dialog } from 'primeng/dialog';
import { Paginator } from 'primeng/paginator';
import { KeycloakService } from '../../core/api/keycloak.service';
import { UserAlertsService } from 'src/app/core/api/userAlerts.service';
@Component({
  selector: 'app-user-layout',
  templateUrl: './user-layout.component.html',
  styleUrls: ['./user-layout.component.scss'],
  providers: [AuthService,DatePipe,OrderService,UserAlertsService],
})

export class UserLayoutComponent implements OnInit {
  isLeadGenerator: boolean = false;
  filterParams: searchFilter;
  theme: Theme = 'light-theme';
  @ViewChild('searchDialog') searchDialog: Dialog;
  companyConnected: any = {};
  username = '';
  rtl: boolean = false;
  languages: any;
  selectedCountry: any = { name: 'English', code: 'UK', language: 'en' };
  isSales: boolean = false;
  isCustomer: boolean = false;
  isAffiliate: boolean = false;
  isChecked: boolean = false;
  isChecked2: boolean = false;
  company: any;
  balance: any;
  limit: any;
  userId : any;
  visibleMessages: any[];
  client:any;
  messages: { body: string, headers: { header: string,timestamp: Date }, read: boolean }[] = [];
  unreadCount: number = 0;
  showNotificationsFlag: boolean = false;
  notificationsOpen: boolean = false;
  currentCompany:any;
  searchQuery: string;
  keycloackToken:string;
  showDropdownOptions: boolean = false;
  selectedCountrySearch: string = '';
  countriesList: string[] = [];
  loadCountries: boolean = false;
  fromDate:any;
  toDate:any;
  loadCities:boolean=false;
  cities:any;
  provinces:any;
  loadProvinces:boolean=false;
  monthNames: string[] = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  paymentList:any=["COD","PREPAID","CCOD"];
  skuList:any=[];
  loadSkus:boolean=false;
  trackingStatusList:any=["InTransit","Processing","NotFound","PickUp","Exception","Delivered","Returned","Returning","Delivered_Payable","Delivered_NotPayable","Delivered_Paid","Delivered_PayablePendingValidation"];
  leadStatusList:any=["NEW","CONFIRMED","RECONFIRMED","PENDING_FOLLOWUP", "CANCELED","NOANSWER","SCHEDULED","UPSELL","WRONGNUMBER","EXCEPTION",/*"DUPLICATED"*/];
  orderStatusList:any=["Open","Exception","Pending","Processing","shipped","Abnormal"];
  
  modalWindow: boolean = false;
  selectedOption: string;
  currentPage = 1;
  selectedData: any;
  rowsPerPage = 10;
  login:any;
  load = false;
  loading = false;
  paginator = { 
    first: 0,
    rows: 50,
    page: 0,
    show: false,
    totalCount: 0,
  };
  totalRecords : number;
  private webMasterId: string | null = null;
  apiCallsInitialized: boolean = false;
  afterLoginMessage: string = '';
  isAfterLoginMessageEnabled: boolean = false;
  showNotice: boolean = false;
  constructor(
    private translate: TranslateService,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private accountService: AccountService,
    private _service: AuthService,
    private route: Router,
    private datePipe: DatePipe, // Inject the DatePipe
    private orderService: OrderService,
    private leadService: LeadsService,
    private productService:ProductService,
    private keycloakService:KeycloakService,
    private userAlertsService:UserAlertsService

  ) { 
    this.webMasterId = localStorage.getItem('webMasterId');
  }

  useLanguage(language: string): any {
    this.rtl = language == 'ar' ? true : false;
    this.translate.use(language);
    localStorage.setItem('language', language);
  }

  intializeRTL() {
    if (localStorage.getItem('language') == 'ar') {
      this.selectedCountry = { name: 'Arabic', code: 'AU', language: 'ar' };
      this.rtl = true;
      this.translate.use('ar');
    } else if (localStorage.getItem('language') == 'fr') {
      this.selectedCountry = { name: 'français', code: 'FR', language: 'fr' };
      this.translate.use('fr');
    } 
    else if (localStorage.getItem('language') == 'cn'){
      this.selectedCountry = { name: 'chinese', code: 'CN', language: 'cn' };
      this.translate.use('cn');
    }else {
      this.selectedCountry = { name: 'English', code: 'UK', language: 'en' };
      this.translate.use('en');
    }
  }

  ngOnInit(): void {   
   
     if (this.webMasterId) {
       this.isLeadGenerator = true;
     }

    this.currentCompany = companies.find((company)=> company.active);
    this.intializeRTL();
    this.initializeTheme();
    this.getConnected();
    this.fetchAlertMessages();
    
    const currentDate: Date = new Date();
    
      const year: number = currentDate.getFullYear();
      const fromyear: number = currentDate.getFullYear() - 1;
      const currentMonth: number = currentDate.getMonth() +1;
      const fromMonth: number = currentDate.getMonth() > 0 ? currentDate.getMonth() : 12;
      const day: number = currentDate.getDate();
      this.fromDate = `${this.monthNames[fromMonth-1].toString().padStart(2, '0')} ${day.toString().padStart(2, '0')},${fromyear}`;
      this.toDate = `${this.monthNames[currentMonth-1].toString().padStart(2, '0')} ${day.toString().padStart(2, '0')},${year}`;
      this.initFilterParams(fromMonth + "/" + day + "/" + fromyear, currentMonth + "/" + day + "/" + year);

    if (this.currentCompany.name == 'Fulfillment Bridge'){
      this.languages = [
        { name: 'Arabic', code: 'AU', language: 'ar' },
        { name: 'English', code: 'UK', language: 'en' },
        { name: 'français', code: 'FR', language: 'fr' },
        { name: 'Chinese', code: 'CN', language: 'cn' },
  
      ];
    }else{
      this.languages = [
        { name: 'Arabic', code: 'AU', language: 'ar' },
        { name: 'English', code: 'UK', language: 'en' },
        { name: 'français', code: 'FR', language: 'fr' }
      ];
    }
    
    this.affiliateSideBar();
    this.salesSideBar();
    this.customerSideBar();
    this.initializeWebStomp();
    this.leadGeneratorSideBar();

    // Retrieve messages from localStorage
  let messages = JSON.parse(localStorage.getItem('messages') || '[]');

  // Limit the maximum number of messages to 50
  const MAX_MESSAGES = 50;
  if (messages.length > MAX_MESSAGES) {
    messages = messages.slice(0, MAX_MESSAGES);
  }

  this.messages = messages.filter((message) => this.companyConnected.id === message.headers.userId)
  .map((message: any) => {
    return {
      body: message.body,
      headers: {
        header: message.headers.header,
        timestamp: new Date(message.headers.timestamp),
      },
      read: message.read,
    };
  });
    // Set visible messages based on the length
    if (this.messages.length > 5) {
      this.visibleMessages = this.messages.slice(0, 5);
    } else {
      this.visibleMessages = this.messages;
    }
    // this.initCountries();
    // this.initCities();
    // this.initprovinces();
    // this.initSkus();
  }
  showMore() {
  const startIndex = this.visibleMessages.length;
  const endIndex = startIndex + 5;
  this.visibleMessages = this.messages.slice(0, endIndex);
  
  this.isChecked2 = true;
  }
   
  getConnected() {
    this.accountService.get().subscribe(
    (companyConnected) => {
      console.log(companyConnected);
    this.companyConnected = companyConnected;
    const { firstName, lastName, company } = this.companyConnected;
    this.username = `${firstName || ''} ${lastName || ''}`;
    this.company = company;
    this.balance = this.company.balance.toFixed(2);
    this.limit = this.company.limit.toFixed(2);
    this.userId = this.companyConnected.id;
    this.login=companyConnected.login;
    this.keycloackToken=companyConnected.keycloackToken;
    console.log("CostumerId",this.companyConnected.id);
    console.log("companyID",companyConnected.company.id);
    sessionStorage.setItem('companyIdForLeadRules', companyConnected.company.id);
    sessionStorage.setItem('customerIdForLeadRules', companyConnected.id);

      },
      (err) => {
        console.log(err);
      },
      () => { }
    );
   
  }
    
  languageChanged(event) {
    this.useLanguage(this.selectedCountry.language);
    localStorage.setItem('language', this.selectedCountry.language);
  }

  switchTheme() {
    this.document.body.classList.replace(
      this.theme,
      this.theme === 'light-theme'
        ? (this.theme = 'dark-theme')
        : (this.theme = 'light-theme')
    );
  }

  affiliateSideBar() {
    this.accountService.isAffiliate().subscribe(
      (data) => {
        this.isAffiliate = !!data;
      },
      (err) => {
        console.log(err);
      }
    );
  }
  salesSideBar() {
    this.accountService.isSales().subscribe(
      (data) => {
        if (data) {
          this.isSales = true;
          //console.log("EskyAdmin");
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  
  initializeWebStomp(): void {
  
    setTimeout(() => {
      const ws = new WebSocket(environment.WebSocket);
  
      // Use the stomp client to connect the websocket to RabbitMQ
      this.client = Stomp.over(ws);
  
      // Set the login and passcode
      const login = environment.WebSocket_login;
      const passcode = environment.WebSocket_passcode;
  
      // Define the onConnect callback function
      const onConnect = () => {
        console.log('Connected to RabbitMQ Web STOMP');
        this.client.subscribe('/queue/' + this.userId, (message) => {
          const newMessage = {
            body: message.body,
            headers: {
              header: message.headers.header,
              timestamp: new Date(Number(message.headers.timestamp)),
              userId : message.headers.userId
            },
            read: false
          };
          this.messages.unshift(newMessage);
          this.unreadCount++;
          this.saveMessages();
          this.visibleMessages.unshift(newMessage);
        });
      }
  
      // Define the onError callback function
      const onError = (error) => {
        console.error('Error connecting to RabbitMQ Web STOMP:', error);
      }
  
      // Connect to RabbitMQ Web STOMP
      this.client.connect(login, passcode, onConnect, onError);
      this.client.debug = (str: string) => {};

    }, 10 * 1000);
  }

  customerSideBar() {
    this.accountService.isCustomer().subscribe(
      (data) => {
        if (data) {
          this.isCustomer = true;
          //console.log("EskyAdmin");
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

   // Fedi add 
   leadGeneratorSideBar() {
    if (this.webMasterId) {
      // If webmasterId exists, user has ROLE_LEAD_GENERATOR role
      this.isLeadGenerator = true;
    }
  }
  

  async logout() {
    // Disconnect from RabbitMQ Web STOMP
    if (this.client && this.client.connected) {
      await this.client.deactivate();
      console.log('Disconnected from RabbitMQ Web STOMP');
    }
    this._service.logout().subscribe(data => {
      this.route.navigate(['/'])
    });
    localStorage.removeItem('webMasterId');
  }
  initializeTheme = (): void =>
    this.renderer.addClass(this.document.body, this.theme);
    
    getMessageClass(header: string, read: boolean): string {
      if (header && header.toLowerCase().includes('success')) {
        return read ? 'successStyle-read' : 'successStyle';
      } else if (header && header.toLowerCase().includes('error')) {
        return read ? 'failureStyle-read' : 'failureStyle';
      } else if (header && header.toLowerCase().includes('update')) {
          return read ? 'updateStyle-read' : 'updateStyle';
      } else if (header && header.toLowerCase().includes('created')) {
        return read ? 'createdStyle-read' : 'createdStyle';
      } else {
        return '';
      }
    }
    
    getMessageIcon(header: string): string {
      if (header && header.toLowerCase().includes('success')) {
        return 'fa-check';
      } else if (header && header.toLowerCase().includes('error')) {
        return 'fa-times';
      } else if (header && header.toLowerCase().includes('update')) {
        return 'fa-pencil';
      } else if (header && header.toLowerCase().includes('created')) {
        return 'fa-check';
      }  else {
        return '';
      }
    }
    getUnreadMessageCount(): number {
      return this.messages.filter(message => !message.read).length;
    }
    showNotifications() {
      if (this.messages.length != 0) {
        this.notificationsOpen = !this.notificationsOpen;
        if (this.notificationsOpen) {
          // Reset the unread count to 0 when the panel is opened
          this.unreadCount = 0;
        } else {
          // Mark all the visible messages as read when the panel is closed
          this.visibleMessages.forEach(message => message.read = true);
          // Recalculate the unread count based on all the unread messages
          this.unreadCount = this.messages.filter(message => !message.read).length;
        }
        this.saveMessages();
      }
    }
    readNotification(index: number) {
      const message = this.messages[index];
      if (!message.read) {
        message.read = true;
        this.unreadCount--;
        this.saveMessages(); // Save messages to localStorage
      }
    }
    toggleNotification() {
      this.showNotificationsFlag = !this.showNotificationsFlag;
      if (this.unreadCount > 0) {
        this.notificationsOpen = true;
        this.unreadCount = 0;
        this.saveMessages(); // Save messages to localStorage
      }
    }
    saveMessages() {
      localStorage.setItem('messages', JSON.stringify(this.messages));
    }


    initFilterParams(fromDate,currentDate) {  
      this.filterParams = {
        isApplied: false,
        isVisible: false,
        searchInput: null,
        countries: null,
        cities:null,
        leadStatus:null,
        orderStatus:null,
        trackingStatus:null,
        provinces:null,
        skus: null,
        paymentType:null,
        creationDateFrom: fromDate,
        creationDateTo: currentDate,
        companies:null
      };
    }

    initCountries(){
      this.orderService.getCountries().subscribe(
        (data: any) => {
          //console.log('countriesList', data);
          this.countriesList = data;
          if(this.isAffiliate){
            this.leadService.getCountries(this.keycloackToken).subscribe(
              (countriesList: any) => {
                //console.log('leads countriesList', countriesList);
                const filteredCountries = countriesList.filter(country => !this.countriesList.includes(country));
                //console.log(filteredCountries)
                this.countriesList.push(...filteredCountries);     
                this.countriesList.sort();       
                //console.log('countriesList', this.countriesList);
                this.loadCountries = !this.loadCountries;
              },
              (err) => {
                console.error('Error getting leads countries list', err);
                this.loadCountries = !this.loadCountries;
              }
            );
          }else{
            this.loadCountries = !this.loadCountries;
          }
        },
        (err) => {
          console.error('Error getting orders countries list', err);
          this.loadCountries = !this.loadCountries;
        }
      );
    }
    initCities(){
      this.orderService.getCities().subscribe(
        (data: any) => {
          //console.log('cities', data);
          this.cities = data;
          if(this.isAffiliate){
            this.leadService.getCities(this.keycloackToken).subscribe(
              (cities: any) => {
                //console.log('leads cities', cities);
                const filtredCities = cities.filter(city => !this.cities.includes(city));
                //console.log(filtredCities)
                this.cities.push(...filtredCities);     
                this.cities.sort();       
                //console.log('cities', this.cities);
                this.loadCities = !this.loadCities;
              },
              (err) => {
                console.error('Error getting leads cities list', err);
                this.loadCities = !this.loadCities;
              }
            );
          }else{
            this.loadCities = !this.loadCities;
          }
        },
        (err) => {
          console.error('Error getting orders cities list', err);
          this.loadCities = !this.loadCities;
        }
      );
    }
    initprovinces(){
      this.orderService.getProvinces().subscribe(
        (data: any) => {
          //console.log('provinces', data);
          this.provinces = data;
          if(this.isAffiliate){
            this.leadService.getProvinces(this.keycloackToken).subscribe(
              (provinces: any) => {
                //console.log('leads provinces', provinces);
                const filtredProvinces = provinces.filter(province => !this.provinces.includes(province));
                //console.log(filtredProvinces)
                this.provinces.push(...filtredProvinces);     
                this.provinces.sort();       
                //console.log('provinces', this.provinces);
                this.loadProvinces = !this.loadProvinces;
              },
              (err) => {
                console.error('Error getting leads provinces list', err);
                this.loadProvinces = !this.loadProvinces;
              }
            );
          }else{
            this.loadProvinces = !this.loadProvinces;
          }
        },
        (err) => {
          console.error('Error getting orders provinces list', err);
          this.loadProvinces = !this.loadProvinces;
        }
      );
    }
    initSkus(){
      this.productService.getVariants().subscribe(
        (data: any) => {
          console.log('skuList', data);
          this.skuList = data;
          if(this.isAffiliate){
            this.leadService.getSkus('Bearer ' + this.keycloackToken).subscribe(
              (skuList: any) => {
                //console.log('leads skuList', skuList);
                const filteredSkus = skuList.filter(sku => !this.skuList.includes(sku));
                console.log(filteredSkus)
                this.skuList.push(...filteredSkus);            
                //console.log('skuList', this.skuList);
                this.loadSkus = !this.loadSkus;
              },
              (err) => {
                console.error('Error getting leads sku list', err);
                this.loadSkus = !this.loadSkus;
              }
            );
          }else{
            this.loadSkus = !this.loadSkus;
          }
        },
        (err) => {
          console.error('Error getting sku list', err);
          this.loadSkus = !this.loadSkus;
        }
      );
    }
    
    showDropdown() {
      if (!this.apiCallsInitialized) {
        this.apiCallsInitialized = true;
        this.initprovinces();
        this.initCountries();
        this.initCities();
        this.initSkus();
      }
      this.showDropdownOptions = true;
    }
    
    stopPropagation() {
      event.stopPropagation();
    }
    
    @HostListener('document:click')
    closeDropdown() {
      this.showDropdownOptions = false;
      this.apiCallsInitialized = false;
    }
    
    openDialog() {
      this.modalWindow = true;
      this.loading = true;
      this.retrieveData();
    }
    convertDateFormat(dateString: string): string {
      console.log(dateString);
    
      // Check if the dateString matches the "Dec 05 2022 00:00:00 GMT+0100 (Central European Standard Time)" format
      const isFullDateFormat = `/\w{3} \d{2} \d{4} \d{2}:\d{2}:\d{2} [A-Z]{3}.*/.test(dateString)`;
    
      if (isFullDateFormat) {
        const dateObject = new Date(dateString);
        const year = dateObject.getFullYear();
        const month = (dateObject.getMonth() + 1).toString().padStart(2, '0');
        const day = dateObject.getDate().toString().padStart(2, '0');
    
        return `${year}-${month}-${day} 00:00:00`;
      } else {
        const dateComponents = dateString.split('/');
    
        if (dateComponents.length === 3) {
          // Check if the dateString matches the "MM/DD/YYYY" format
          const isMMDDYYYYFormat = `/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)`;
          if (isMMDDYYYYFormat) {
            return `${dateComponents[2]}-${dateComponents[0]}-${dateComponents[1]} 00:00:00`;
          }
        }
    
        return '';
      }
    }
    retrieveData() {
      
      const page = this.currentPage - 1; 
      const size = this.rowsPerPage;

      this.getOrderData(page, size); 
    }
    getOrderData(page: number, size: number) {
        console.log("hre1",this.currentPage);
        console.log('filter params111 : ', this.filterParams);
        this.filterParams.isApplied = true;
        this.filterParams.creationDateFrom = this.convertDateFormat(this.filterParams.creationDateFrom);
        this.filterParams.creationDateTo = this.convertDateFormat(this.filterParams.creationDateTo);
        console.log(`Formatted date from: ${this.filterParams.creationDateFrom}`);
        console.log(`Formatted date to1: ${this.filterParams.creationDateTo}`);
        /*
        let dateComponents: any[] = this.filterParams.creationDateFrom.split('/');
        this.fromDate = `${this.monthNames[dateComponents[0]-1].toString().padStart(2, '0')} ${dateComponents[1].toString().padStart(2, '0')},${dateComponents[2]}`;
        dateComponents = this.filterParams.creationDateTo.split('/');
        this.toDate = `${this.monthNames[dateComponents[0]-1].toString().padStart(2, '0')} ${dateComponents[1].toString().padStart(2, '0')},${dateComponents[2]}`;
        console.log(`Formatted date from222: ${this.filterParams.creationDateFrom}`);
        console.log(`Formatted date to22: ${this.filterParams.creationDateTo}`);*/
        for (const field in this.filterParams) {
          if (this.filterParams.hasOwnProperty(field) && Array.isArray(this.filterParams[field]) && this.filterParams[field].length === 0) {
            this.filterParams[field] = null;
          }
        }
        this.filterParams = { ...this.filterParams };
        this.filterParams.isVisible = false;
      this.orderService.searchOrdersCount(this.filterParams).subscribe(
        (ordersCount: number) => {
          this.totalRecords = Number(ordersCount);
          this.leadService.searchLeadsCount(this.keycloackToken, this.filterParams).subscribe(
            (leadsCount: number) => {
              this.totalRecords = Math.max(this.totalRecords, Number(leadsCount));
            }
          );
        }
      );
    
      this.orderService.searchOrders(this.filterParams, page, size).subscribe(
        (ordersResponse) => {
          const orders = Array.isArray(ordersResponse) ? ordersResponse : [ordersResponse];
          const mergedData = orders.map(order => [null, null, order.orderId, order.orderStatus, order.trackingNumber, order.lastTrackingStatus, order.countryCode]);
    
          this.leadService.searchLeads(this.keycloackToken, this.filterParams, page, size).subscribe(
            (leadsResponse) => {
              const leads = Array.isArray(leadsResponse) ? leadsResponse : [leadsResponse];
              leads.forEach(lead => {
                const existingRow = mergedData.find(row => row[2] === lead.referenceNumber);
                if (existingRow) {
                  existingRow[0] = lead.referenceNumber;
                  existingRow[1] = lead.leadStatus;
                  existingRow[6] = lead.countryCode;
                } else {
                  mergedData.push([lead.referenceNumber, lead.leadStatus, null, null, null, null, lead.countryCode]);
                }
              });
    
              this.selectedData = {
                columns: ['Reference Number', 'Lead Status', 'Order ID', 'Order Status', 'Tracking Number', 'Tracking Status', 'Country'],
                rows: mergedData
              };
    
              this.loading = false;
            },
            (leadsError) => {
              console.log(leadsError);
              this.loading = false;
            }
          );
        },
        (ordersError) => {
          console.log(ordersError);
          this.loading = false;
        }
      );
    }
    

    onPageChange(event: any) {
      if (this.paginator) {
        this.currentPage = event.page + 1;
        this.loading = true;
        this.retrieveData();
      }
    }
  
    closeDialog() {
      this.modalWindow = false;
      const currentDate: Date = new Date();
      
      const year: number = currentDate.getFullYear();
      const fromyear: number = currentDate.getFullYear() - 1;
      const currentMonth: number = currentDate.getMonth() +1;
      const fromMonth: number = currentDate.getMonth() > 0 ? currentDate.getMonth() : 12;
      const day: number = currentDate.getDate();
      this.fromDate = `${this.monthNames[fromMonth-1].toString().padStart(2, '0')} ${day.toString().padStart(2, '0')},${fromyear}`;
      this.toDate = `${this.monthNames[currentMonth-1].toString().padStart(2, '0')} ${day.toString().padStart(2, '0')},${year}`;
      this.initFilterParams(fromMonth + "/" + day + "/" + fromyear, currentMonth + "/" + day + "/" + year);
      this.currentPage = 1;
      this.selectedData =null;
      console.log(this.currentPage)
    }
    isArabicLanguage(): boolean {
      const arabicRegex = /[\u0600-\u06FF]/;
      return arabicRegex.test(this.afterLoginMessage);
    }
    closeNotice(): void {
      this.showNotice = false;
    }
    
    fetchAlertMessages() {
      this.userAlertsService.getAlertMessages().subscribe(
        data => {
          const company = data.find(c => c.name === this.currentCompany.name);
          if (company) {
            this.afterLoginMessage = company.afterLoginMessage;
            this.isAfterLoginMessageEnabled =  company.enabled.afterLoginMessage;
          }

    
          if (this.isAfterLoginMessageEnabled && this.afterLoginMessage.trim() !== '') {
            this.showNotice = true;
            
          }
        },
        error => {
          console.error('Error fetching alert messages:', error);
        }
      );
    }
    
}
export type Theme = 'light-theme' | 'dark-theme';